import type { PropsWithChildren } from "react";
import type {
  FieldValues,
  SubmitHandler,
  UseFormReturn,
} from "react-hook-form";
import { FormProvider } from "react-hook-form";
import { useScrollToTop } from "../../hooks/useScrollToTop";

type FormProps<T extends FieldValues> = PropsWithChildren<{
  onSubmit?: SubmitHandler<T>;
  formMethods: UseFormReturn<T>;
  className?: string;
  scrollToTop?: boolean;
  csrfToken?: string;
  hidden?: boolean;
  onError?: () => void;
}>;

export function Form<T extends FieldValues>({
  onSubmit = () => null,
  formMethods,
  children,
  className,
  scrollToTop = true,
  csrfToken,
  hidden = false,
  onError,
  ...rest
}: FormProps<T>) {
  const { handleSubmit } = formMethods;

  const formRef = useScrollToTop<HTMLFormElement>(!scrollToTop, []);

  return (
    <FormProvider {...formMethods}>
      <form
        className={className ?? "font-inter flex flex-col p-2"}
        hidden={hidden}
        onSubmit={
          handleSubmit(
            onSubmit,
            onError
          ) as React.FormEventHandler<HTMLFormElement>
        }
        ref={formRef}
        {...rest}
      >
        <input name="CSRFToken" type="hidden" value={csrfToken ?? ""} />
        <input name="csrf_token" type="hidden" value={csrfToken ?? ""} />
        {children}
      </form>
    </FormProvider>
  );
}
